import { success, error, abort } from 'redux-saga-requests';
import { COMPARE_AUDIT } from '../constants';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMPARE_AUDIT: {
      return {
        ...state,
        [action.meta.name]: {
          response: state[action.meta.name] ? state[action.meta.name].response : undefined,
          resolved: false,
          failed: false,
          error: null,
        },
      };
    }
    case success(COMPARE_AUDIT): {
      return {
        ...state,
        [action.meta.name]: {
          response: action.payload.data.content,
          resolved: true,
          failed: false,
          error: null,
        },
      };
    }
    case error(COMPARE_AUDIT): {
      if (action.payload.response.status >= 400 && action.payload.response.status < 600) {
        return {
          ...state,
          [action.meta.name]: {
            resolved: true,
            failed: true,
            error: action.payload.response.data.result.errorCode,
          },
        };
      }
      return {
        ...state,
        [action.meta.name]: {
          resolved: true,
          failed: true,
          error: action.payload.toString ? action.payload.toString() : '',
        },
      };
    }
    case abort(COMPARE_AUDIT):
      return {
        ...state,
      };
    default:
      return state;
  }
}
